export function applyFontSize(parent: HTMLElement, fontSize: string) {
  parent.querySelectorAll<HTMLElement>('[data-resizable-sample]').forEach((sample) => {
    sample.style.setProperty('font-size', `${fontSize}px`);
  });
}

export function applySampleText(parent: HTMLElement, sampleText: string) {
  parent.querySelectorAll('[data-editable-sample]').forEach(sample => {
    sample.setAttribute('previewstring', sampleText);
    sample.textContent = sampleText;
  });
}

export function applyListView(parent: HTMLElement, isListView: boolean) {
  parent.querySelectorAll('[data-toggle-view]').forEach(element => {
    element.toggleAttribute('listview', isListView);
  });
}

export function revertSampleElementsToFamilyDefaults(parent: HTMLElement) {
  parent.querySelectorAll<HTMLElement>('[data-editable-sample]').forEach((element) => {
    const familyDefault = element.dataset.defaultSampleText ?? '';
    element.setAttribute('previewstring', familyDefault);
    element.innerText = familyDefault;
  });
}
